export const workList = [{
        jobTitle: "Frontend developer ",
        companyName: "@Coolblue",
        years: "May 2019 - present",
        information: "Currently working at the sales department, responsible for creating banner ads using Vanilla JavaScript and React.",
        place: "Rotterdam, The Netherlands",
        website: "https://www.coolblue.nl",
        languages: [{
                languageName: "HTML",
                color: "default"
            },
            {
                languageName: "SCSS/CSS",
                color: "default"
            },
            {
                languageName: "JavaScript",
                color: "default"
            },
            {
                languageName: "React",
                color: "default"
            },
            {
                languageName: "Angular",
                color: "default"
            },
            {
                languageName: "Vue.js",
                color: "default"
            },
            {
                languageName: "gsap",
                color: "default"
            },
            {
                languageName: "Webpack",
                color: "default"
            },
            {
                languageName: "npm",
                color: "default"
            }
        ]
    },
    {
        jobTitle: "Frontend developer",
        companyName: "@Connect Holland",
        years: "Feb 2018 - Apr 2019",
        information: "Creating full responsive websites for different clients using frameworks like Angular.",
        place: "Rotterdam, The Netherlands",
        website: "https://www.connectholland.nl",
        languages: [{}]
    },
    {
        jobTitle: "Frontend development & UX design intern",
        companyName: "@Connect Holland",
        years: "Feb 2018 - Jun 2018",
        information: "Designed and developed an interactive dashboard for customers to use at the entrance of the office using Vue.",
        place: "Rotterdam, The Netherlands",
        website: "https://www.connectholland.nl",
        languages: [{}]
    },
    {
        jobTitle: "Web development intern",
        companyName: "@Connect Holland",
        years: "Aug 2016 - Dec 2016",
        information: "Focused on both frontend and backend using Symfony, Angular and a headless CMS.",
        place: "Rotterdam, The Netherlands",
        website: "https://www.connectholland.nl",
        languages: [{}]
    }
]